const SYSTEM_STATUS_LABELS = {
    690970000: "Unscheduled",
    690970001: "Scheduled",
    690970002: "In Progress",
    690970003: "Completed",
    690970004: "Posted",
    690970005: "Canceled",
};
export function workOrderStatus(code, formattedLabel) {
    if (formattedLabel)
        return formattedLabel;
    if (code != null && SYSTEM_STATUS_LABELS[code])
        return SYSTEM_STATUS_LABELS[code];
    console.warn("[Dataverse] Unrecognized Work Order System Status:", code);
    return code == null ? "Unknown" : `Unknown (${code})`;
}
